export default __webpack_public_path__ + "static/media/Wolf's Boots of the Bloody Fang.906f621b.jpg";